import tippy from 'tippy.js';

const DEFAULTS = {
  arrow: true,
  animation: 'fade',
  appendTo: 'parent',
  placement: 'top',
  interactive: true,
  theme: 'light-border',
  maxWidth: 240,
};

const getOptions = options => Object.assign({}, DEFAULTS, options || {});

const initTooltip = (selector, options) => {
  tippy(selector, getOptions(options));
};

export default (selector, options) => {
  initTooltip(selector, options);
};
